export default "__VITE_ASSET__DoCTUG7I__"